import { defineMessages } from 'react-intl';

const translations = {
  subscribe: {
    id: 'pages.contract.apps.subscribe',
    defaultMessage: 'Subscribe',
    description: 'Label of the app subscribe button',
  },
  unsubscribe: {
    id: 'pages.contract.apps.unsubscribe',
    defaultMessage: 'Unsubscribe',
    description: 'Label of the app unsubscribe button',
  },
  active: {
    id: 'pages.contract.apps.active',
    defaultMessage: 'Active',
    description: 'Label of the app active status',
  },
  page: {
    feedback: {
      subscriptionAdded: {
        id: 'pages.contract.apps.feedback.subscriptionAdded',
        defaultMessage: 'Subscription added',
        description: 'success feedback message of the subscription add action',
      },
      subscriptionNotAdded: {
        id: 'pages.contract.apps.feedback.subscriptionNotAdded',
        defaultMessage: 'Subscription could not be added',
        description: 'error feedback message of the subscription add action',
      },
    },
  },
};

export default defineMessages(translations);
